import * as RadixTabs from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';
import styles from './Tabs.module.css';

export interface TabItem {
  value: string;
  label: ReactNode;
  count?: number;
  /**
   * Second line under the label, for tabs whose name alone does not say what
   * they cover — the solution areas carry one ("Azure — Frontier Accelerate")
   * in the guide, and dropping it loses the only cue to what each area is for.
   */
  sub?: string;
}

interface TabsProps {
  value: string;
  onChange: (value: string) => void;
  items: readonly TabItem[];
  ariaLabel: string;
}

/** A row of filter/section tabs — used for area navigation and list filters. */
export function Tabs({ value, onChange, items, ariaLabel }: TabsProps): React.JSX.Element {
  return (
    <RadixTabs.Root value={value} onValueChange={onChange}>
      <RadixTabs.List className={styles.list} aria-label={ariaLabel}>
        {items.map((item) => (
          <RadixTabs.Trigger
            key={item.value}
            value={item.value}
            className={item.sub ? `${styles.trigger} ${styles.triggerStacked}` : styles.trigger}
          >
            <span className={styles.labelRow}>
              {item.label}
              {item.count !== undefined && <span className={styles.count}>{item.count}</span>}
            </span>
            {item.sub && <span className={styles.sub}>{item.sub}</span>}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
    </RadixTabs.Root>
  );
}
